export * from "./score";
export * from "./plan";

export type TApp = "classroom" | "memory" | "choir";
